import { Card, Space, Typography } from 'antd';
import { EyebrowLabel } from '@viq-admin/ui';
import type { LeadDetail } from './types';

interface Props {
  tasks: LeadDetail['tasks'];
}

export function TasksPanel({ tasks }: Props) {
  const openTasks = tasks.filter((t) => !t.isComplete);
  const doneTasks = tasks.filter((t) => t.isComplete);

  return (
    <Card size="small">
      <EyebrowLabel>Tasks</EyebrowLabel>
      {tasks.length === 0 ? (
        <Typography.Text type="secondary">No tasks.</Typography.Text>
      ) : (
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          <Typography.Text type="secondary">
            Tasks ({openTasks.length} open · {doneTasks.length} done)
          </Typography.Text>

          {openTasks.map((t) => (
            <div key={t.id}>
              <Typography.Text>{t.description}</Typography.Text>
              {t.dueDate && (
                <Typography.Text type="secondary">
                  {' '}· Due {new Date(t.dueDate).toLocaleDateString()}
                </Typography.Text>
              )}
            </div>
          ))}

          {doneTasks.map((t) => (
            <div key={t.id}>
              <Typography.Text delete type="secondary">
                {t.description}
              </Typography.Text>
            </div>
          ))}
        </Space>
      )}
    </Card>
  );
}
